import React, {useEffect, useState} from "react";
import {Col, Container, Row} from "react-bootstrap";
import "./styles.scss";
import "../components/styles.scss";
import CurriculumComponent from "../components/CurriculumComponent";
import {useFirestore, useFunctions} from "reactfire";
import UserNotification from "../../../../../../../../shared/components/Notification/UserNotification";
import {Country} from "../../../../../../../../shared/constants/Constant";
import PageHeader from "../../../../../../components/page-header/PageHeader";
import {useWorkshops} from "../../../../../../../../contexts/workshops-context/WorkshopsContext";
import {MdAdd} from "react-icons/md";
import FormValidator from "../../../../../../../../shared/utils/FormValidator";
import ConfirmationModal from "../../../../../../../../shared/components/confirmationModal/ConfirmationModal";
import {FaPencilAlt} from "react-icons/fa";
import {useAppUser} from "../../../../../../../../contexts/user-context/UserContext";
import SelectCountry from "../../../../../../../../shared/components/countrySelectorModal/SelectCountry";
import {HiOutlineClipboardCopy} from "react-icons/hi";
import WorkshopCopyModel from "../../../../components/workshop-copy-model/WorkshopCopyModel";

interface Workshop {
  workshopId: string;
  title: string;
  workshopNumber: string;
  description: string;
  orderNo: number;
  TitleError: string;
  DescriptionError: string;
}

interface ICurriculum {
  id: string;
  courseTitle: string;
  courseDescription: string;
  country: Country;
  workshops: Workshop[];
  courseTitleError: string;
  courseDescriptionError: string;
}

interface State {
  showAcceptConfirmation: boolean;
  showClearConfirmation: boolean;
  loading: boolean;
}

const initState: State = {
  showAcceptConfirmation: false,
  showClearConfirmation: false,
  loading: false,
};

const initCurriculum: ICurriculum = {
  id: "workshopId",
  courseTitle: "course title",
  courseDescription: "",
  country: Country.SRI_LANKA,
  workshops: [],
  courseTitleError: "",
  courseDescriptionError: "",
};

const Curriculums = () => {
  const appUser = useAppUser();
  const workshopsHook = useWorkshops();
  const store = useFirestore();
  const [isUpdate, setIsUpdate] = useState(false);
  const [previewState, setPreviewState] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [state, setState] = useState(initState);
  const [ite, setIndex] = useState(0);
  const [curriculum, setCurriculum] = useState({
    ...initCurriculum,
    country: workshopsHook.country,
  });

  const refSaveCurr = useFunctions().httpsCallable("saveCurriculum");
  const refUpdateCurr = useFunctions().httpsCallable("updateCurriculum");

  useEffect(() => {
    if (workshopsHook.country !== "DEFAULT") {
      setCurriculum((prevState) => {
        return Object.assign(
          {},
          {
            id: "",
            courseTitle: prevState.courseTitle,
            courseDescription: "",
            workshops: [],
            courseTitleError: "",
            courseDescriptionError: "",
            country: workshopsHook.country,
          }
        );
      });
      setIndex(0);
      setIsUpdate(false);
      setPreviewState(true);
    } else {
      setModalShow(true);
    }
  }, [workshopsHook, workshopsHook.country]);

  useEffect(() => {
    store
      .collection("curriculums")
      .where("country", "==", curriculum.country)
      .onSnapshot({}, (snapshot) => {
        if (!snapshot.empty) {
          setIsUpdate(true);
          setPreviewState(true);

          snapshot.docChanges().forEach((change) => {
            if (change.type === "added" || change.type === "modified") {
              setCurriculum({
                id: change.doc.id,
                courseTitle: change.doc.data().courseTitle,
                courseDescription: change.doc.data().courseDescription,
                country: change.doc.data().country,
                workshops: change.doc.data().workshops || [],
                courseTitleError: "",
                courseDescriptionError: "",
              });
            }

            if (change.type === "removed") {
              setCurriculum({
                id: "",
                courseTitle: "course title",
                courseDescription: "",
                country: change.doc.data().country,
                workshops: [],
                courseTitleError: "",
                courseDescriptionError: "",
              });
            }
          });
        } else {
          setCurriculum({
            id: "",
            courseTitle: "course title",
            courseDescription: "",
            country: curriculum.country,
            workshops: [
              {
                workshopId: "workshopId",
                description: "",
                orderNo: 1,
                title: "",
                workshopNumber: "WORKSHOP ",
                DescriptionError: "",
                TitleError: "",
              },
            ],
            courseTitleError: "",
            courseDescriptionError: "",
          });
          setPreviewState(!appUser.userRole.isModerator);
          setIsUpdate(false);
        }
      });
  }, [store, curriculum.country, appUser.userRole.isModerator]);

  useEffect(() => {
    if (!previewState && curriculum.workshops.length <= 0) {
      const tmpArray = [...curriculum.workshops];
      tmpArray.push({
        workshopId: "workshopId",
        description: "",
        orderNo: 1,
        title: "",
        workshopNumber: "WORKSHOP ",
        DescriptionError: "",
        TitleError: "",
      });

      setCurriculum({
        ...curriculum,
        workshops: tmpArray,
      });
    }
  }, [previewState, curriculum, curriculum.workshops]);

  const saveCurriculum = () => {
    setState({
      ...state,
      loading: true,
    });

    const reqCurriculum = {
      courseTitle: "test",
      courseDescription: curriculum.courseDescription,
      country: curriculum.country,
    };

    refSaveCurr(reqCurriculum)
      .then((res) => {
        setCurriculum({
          ...curriculum,
          id: res.data.data,
        });

        res.data.data &&
        res.data.data !== "" &&
        updateCurriculum(res.data.data);

        // if (curriculum.workshops.length > 0) {
        //   setCurriculum({
        //     ...curriculum,
        //     id: res.data.data,
        //   });
        //
        //   res.data.data &&
        //   res.data.data !== "" &&
        //   updateCurriculum(res.data.data);
        // } else {
        //   setIndex(0);
        //   UserNotification({
        //     isSuccess: true,
        //     message: "Curriculum successfully created!",
        //   });
        //   setIsUpdate(true);
        //   setPreviewState(true);
        // }
      })
      .catch((err) => {
        UserNotification({
          isSuccess: false,
          message: "Curriculum creation failed!\nPlease check your connection.",
        });
      })
      .finally(() => {
        setState({
          ...state,
          showAcceptConfirmation: false,
          loading: false,
        });
      });
  };

  const updateCurriculum = (id?: string) => {
    setState({
      ...state,
      loading: true,
    });

    const reqWorkshops: {
      workshopId: string;
      title: string;
      description: string;
      orderNo: number;
    }[] = [];

    curriculum.workshops.forEach((workshop, i) => {
      reqWorkshops.push({
        workshopId: workshop.workshopId,
        title: workshop.title,
        description: workshop.description || "",
        orderNo: workshop.orderNo,
      });
    });

    const reqCurriculum = {
      id: id || curriculum.id,
      courseTitle: "test",
      courseDescription: curriculum.courseDescription,
      country: curriculum.country,
      workshops: reqWorkshops,
    };

    refUpdateCurr(reqCurriculum)
      .then((res) => {
        UserNotification({
          isSuccess: true,
          message: "Curriculum successfully updated!",
        });
        setIndex(0);
        setIsUpdate(true);
        setPreviewState(true);
      })
      .catch((err) => {
        UserNotification({
          isSuccess: false,
          message: "Curriculum updating failed!\nPlease check your connection.",
        });
      })
      .finally(() => {
        setState({
          ...state,
          showAcceptConfirmation: false,
          loading: false,
        });
      });
  };

  const updateWorkshopsDes = (text: string, index: number) => {
    let items = [...curriculum.workshops];
    let item = {...items[index]};
    item.description = text;
    items[index] = item;

    setCurriculum({
      ...curriculum,
      workshops: items,
    });
  };

  const updateWorkshopsTitle = (text: string, index: number) => {
    let items = [...curriculum.workshops];
    let item = {...items[index]};
    item.title = text;
    items[index] = item;

    setCurriculum({
      ...curriculum,
      workshops: items,
    });
  };

  const buttonSet = (
    <Row className="p-2">
      <Col xs={12} className="text-right">
        <div
          className="cancel-button blue"
          style={{marginRight: "15px"}}
          onClick={() => {
            if (!state.loading) {
              setState({
                ...state,
                showClearConfirmation: true,
              });
            }
          }}
        >
          Clear
        </div>
        <div
          className="save-button"
          onClick={() => {
            !state.loading &&
            validateCurriculumsData() &&
            validateWorkshopData() &&
            setState({
              ...state,
              showAcceptConfirmation: true,
            });
          }}
        >
          Save
        </div>
      </Col>
    </Row>
  );

  const validateWorkshopData = (): boolean => {
    let allPassed: boolean = true;
    curriculum.workshops.forEach((ws, index) => {
      const wtValidation = FormValidator.validateString(
        ws.title,
        "Workshop title",
        3,
        100
      );

      const wdValidation = FormValidator.validateQuestionBody(
        ws.description,
        "Workshop description",
        3,
        1000
      );

      const tmpItems = [...curriculum.workshops];
      tmpItems[index].TitleError = wtValidation.message;
      tmpItems[index].DescriptionError = wdValidation.message;

      setCurriculum({
        ...curriculum,
        workshops: tmpItems,
      });

      allPassed = allPassed && wtValidation.isValid && wdValidation.isValid;
    });

    return allPassed;
  };

  const validateCurriculumsData = (): boolean => {
    const ctValidation = FormValidator.validateString(
      curriculum.courseTitle,
      "Course Title",
      3,
      100
    );

    const cdValidation = FormValidator.validateString(
      curriculum.courseDescription,
      "Course Description",
      3,
      1000
    );

    setCurriculum({
      ...curriculum,
      courseTitleError: ctValidation.message,
      courseDescriptionError: cdValidation.message,
    });

    return ctValidation.isValid && cdValidation.isValid;
  };

  const removeWorkshop = (index: number) => {
    const tempWorkshops = [...curriculum.workshops];
    tempWorkshops.splice(index, 1);
    setCurriculum((prevState) => {
      return Object.assign(
        {},
        {
          ...prevState,
          workshops: tempWorkshops,
        }
      );
    });
  }

  const [showCopyDialog, setShowCopyDialog] = useState(false);

  return (
    <>
      <PageHeader title="Curriculum"/>
      <Container
        fluid
        style={{
          paddingTop: "200px",
          paddingLeft: "50px",
          paddingRight: "50px",
        }}
      >
        {workshopsHook.country !== "DEFAULT" ? (
            <>
            {appUser.userRole.isAdmin && !previewState && (
              <Row className="mb-3">
                <Col xs={12}>
                  <div
                    className="text-right"
                    style={{
                      color: "#959090",
                      fontWeight: "bold",
                      fontSize: "18px",
                    }}
                  >
                    Copy content from{" "}
                    <span style={{fontSize: "30px"}}>
                      <HiOutlineClipboardCopy
                        onClick={() => setShowCopyDialog(true)}
                        style={{
                          transform: "scaleX(-1)",
                          color: "#006699",
                          cursor: "pointer",
                        }}
                      />
                    </span>
                  </div>
                </Col>
              </Row>
            )}
            {(appUser.userRole.isAdmin || appUser.userRole.isModerator) &&
            (!previewState ? (
              buttonSet
            ) : (
              <Row>
                <Col xs={12} className="d-flex justify-content-end">
                  {
                    <div
                      className="edit mr-2"
                      onClick={(e) => {
                        setPreviewState(false);
                      }}
                    >
                      <FaPencilAlt/> <span>Edit</span>
                    </div>
                  }
                </Col>
              </Row>
            ))}
            <Row>
              <Col
                xs={12}
                className="text-left font-weight-bold"
                style={{color: "rgb(7, 66, 94)", width: "100%"}}
              >
                {previewState ? (
                  <p>{curriculum.courseDescription}</p>
                ) : (
                  <>
                    <label style={{color: "#505050", fontWeight: "bold"}}>
                      Curriculum Description{" "}
                      <span className="ml-1" style={{color: "red"}}>
                        *
                      </span>
                    </label>
                    <textarea
                      style={{minHeight: "200px"}}
                      className={
                        curriculum.courseDescriptionError.length < 1
                          ? "app-input"
                          : "app-input invalid"
                      }
                      onChange={(e) => {
                        setCurriculum({
                          ...curriculum,
                          courseDescription: e.target.value,
                          courseDescriptionError: "",
                        });
                      }}
                      placeholder="Add a brief description about the workshops in this library."
                      value={curriculum.courseDescription}
                    />
                    <label className="error-message">
                      {curriculum.courseDescriptionError}
                    </label>
                  </>
                )}
              </Col>
            </Row>
            {previewState
              ? curriculum.workshops &&
              curriculum.workshops.length > 0 &&
              curriculum.workshops.map((value: Workshop, index) => {
                if (value.title && value.description) {
                  return (
                    <div key={index}>
                      <CurriculumComponent
                        preview={true}
                        description={value.description || ""}
                        wkNumber={index + 1}
                        title={value.title}
                        onChangeTinyMCE={() => {
                        }}
                        onTitleChange={() => {
                        }}
                        onRemoveWorkshop={() => {
                        }}
                        titleError=""
                        descriptionError=""
                      />
                    </div>
                  );
                } else {
                  return <div key={index}/>;
                }
              })
              : curriculum.workshops &&
              appUser.userRole.isModerator &&
              curriculum.workshops.length > 0 &&
              curriculum.workshops.map((value: Workshop, index: number) => {
                return (
                  <div key={index}>
                    <CurriculumComponent
                      preview={false}
                      description={value.description || ""}
                      wkNumber={index + 1}
                      title={value.title}
                      onChangeTinyMCE={(text: string) => {
                        updateWorkshopsDes(text, index);
                      }}
                      onTitleChange={(text: string) => {
                        updateWorkshopsTitle(text, index);
                      }}
                      onRemoveWorkshop={(index: number) => {
                        removeWorkshop(index);
                      }}
                      titleError={value.TitleError || ""}
                      descriptionError={value.DescriptionError || ""}
                    />
                  </div>
                );
              })}
            {!previewState && (
              <>
              <Row className="mb-2">
              <Col style={{width: "100%"}}>
              <div className="workshop-add-wrapper">
              <div
              className="workshop-add-button"
              onClick={() => {
              const tmpArray = [...curriculum.workshops];
              tmpArray.push({
              workshopId: "workshopId",
              title: "",
              workshopNumber: "WORKSHOP ",
              description: "",
              orderNo: 0,
              TitleError: "",
              DescriptionError: "",
            });

              setCurriculum((prevState) => {
              return Object.assign(
            {},
            {
              ...prevState,
              workshops: tmpArray,
            }
              );
            });
              setIndex(ite + 1);
            }}
              >
              <MdAdd />
              </div>
              <div className="workshop-add-line"></div>
              </div>
              </Col>
              </Row>
              <Row>
              <SelectCountry
              show={modalShow}
              onHide={() => {
              setModalShow(false);
            }}
              />
              </Row>
            {state.showAcceptConfirmation && (
              <ConfirmationModal
              children={{
              bodyText: "Are you sure you want to save the changes?",
              headerText: "Confirm Changes",
              confirmButtonText: "Save",
              cancelButtonText: "Cancel",
              confirmButtonColor: "green",
            }}
              loading={state.loading}
              show={state.showAcceptConfirmation}
              onCancel={() =>
              !state.loading &&
              setState({...state, showAcceptConfirmation: false})
            }
              onConfirm={() => {
              if (!state.loading) {
              if (isUpdate) {
              updateCurriculum();
            } else {
              saveCurriculum();
            }
            }
            }}
              />
              )}
            {state.showClearConfirmation && (
              <ConfirmationModal
              children={{
              bodyText:
              "Are you sure you want to clear all the content?",
              headerText: "Confirmation",
              confirmButtonText: "Clear",
              cancelButtonText: "Cancel",
              confirmButtonColor: "red",
            }}
              loading={state.loading}
              show={state.showClearConfirmation}
              onCancel={() =>
              !state.loading &&
              setState({...state, showClearConfirmation: false})
            }
              onConfirm={() => {
              if (!state.loading) {
              setCurriculum((prevState) => {
              return Object.assign(
            {},
            {
              id: prevState.id,
              courseTitle: prevState.courseTitle,
              courseDescription: "",
              workshops: [],
              courseTitleError: "",
              courseDescriptionError: "",
              country: prevState.country,
            }
              );
            });
              setState({...state, showClearConfirmation: false});
            }
            }}
              />
              )}
              </>
              )}
              </>
              ) : (
              <></>
              )}
            </Container>
          <WorkshopCopyModel
            show={showCopyDialog}
            onHide={() => setShowCopyDialog(false)}
            activeList={{
              curriculum: true,
              libraryHome: false,
              workshopContent: false,
            }}
          />
          </>
          );
        };

        export default Curriculums;
